<div [ngClass]="isMobile ? 'h-[100vh]' : 'min-h-[700px] max-h-[700px]'" class="app-container mobile:w-full" #appContainer>
	<div class="content" #mobileView>
		<div class="install-header" *ngIf="!isDesktop && !environment.whiteLabel" [ngStyle]="{ 'border-radius': isMobile ? 'none' : '24px 24px 0 0' }" (click)="linkService.installJotto(channel.uuid,
		channel.share_url,
		LINK_TYPES.CHANNEL)">
			<span><b>Jotto is better in the app! Click here to install now.</b></span>
		</div>
		<portals-channel-feed [notifications]="notifications" [channel]="channel" [portalUser]="true" [maxFeedHeight]="maxFeedHeight" [feedWidth]="isMobile ? '100%' : feedWidth"></portals-channel-feed>
	</div>
</div>
